import { darken, getContrastRatio, lighten } from '@mui/material/styles';
import type { Theme } from '@mui/material/styles';

export const getDeltaTextColor = (muiTheme: Theme, isPositive: boolean): string => {
  const isDarkMode = muiTheme.palette.mode === 'dark';
  const baseColor = isPositive
    ? isDarkMode
      ? muiTheme.palette.success.light
      : muiTheme.palette.success.dark
    : isDarkMode
      ? muiTheme.palette.error.light
      : muiTheme.palette.error.dark;
  const backgrounds = [
    muiTheme.palette.background.default,
    muiTheme.palette.background.paper,
  ].filter((value, index, list) => list.indexOf(value) === index);
  const meetsContrast = (color: string): boolean =>
    backgrounds.every((background) => getContrastRatio(color, background) >= 4.5);
  if (meetsContrast(baseColor)) return baseColor;
  const adjust = muiTheme.palette.mode === 'dark' ? lighten : darken;
  const steps =
    muiTheme.palette.mode === 'dark' ? [0.2, 0.3, 0.4, 0.5, 0.6] : [0.1, 0.2, 0.3, 0.4, 0.5];
  for (const step of steps) {
    const candidate = adjust(baseColor, step);
    if (meetsContrast(candidate)) return candidate;
  }
  return baseColor;
};
